import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
  container: {
    paddingBottom: theme.spacing(4),
  },
  paper: {
    padding: theme.spacing(2),
    display: 'flex',
    overflow: 'auto',
    flexDirection: 'column',
  },
  fixedHeight: {
    height: 230,
  },
  logoWrapper: {
    textAlign: 'center',
  },
  logo: {
    height: '150px',
    width: '150px',
  },
  hide: {
    marginTop: '10rem',
    marginBottom: '10rem',
  },
  purchase: {
    cursor: 'pointer',
  },
}));
